document.addEventListener('DOMContentLoaded', () => {
  const typeSelect = document.querySelector('select[name="options[Type]"]');
  const getModelSelect = () => document.querySelector('select[name="options[Model]"]');
  const modelContainer = getModelSelect()?.parentNode;

  if (!typeSelect || !modelContainer) return;

  let samsungModels = [];
  let iphoneModels = [];

  // 🔁 Declare observer early so it's accessible in all functions
  const observer = new MutationObserver((mutations) => {
    const modelSelect = getModelSelect();
    if (modelSelect) {
      cacheModelOptions(modelSelect);
      updateModelOptions();
    }
  });

  function cacheModelOptions(modelSelect) {
    const allModelOptions = Array.from(modelSelect.options);

    samsungModels = [];
    iphoneModels = [];

    allModelOptions.forEach(option => {
      const text = option.textContent.toLowerCase();
      const modelData = {
        value: option.value,
        label: option.label || option.textContent,
        dataset: { ...option.dataset }
      };
      if (text.includes('samsung')) samsungModels.push(modelData);
      else if (text.includes('iphone')) iphoneModels.push(modelData);
    });
  }

  function updateModelOptions() {
    const modelSelect = getModelSelect();
    if (!modelSelect) return;

    observer.disconnect(); // 👈 Stop observer temporarily

    const selectedType = typeSelect.value.trim().toLowerCase();
    modelSelect.innerHTML = '';

    let modelsToUse = selectedType === 'samsung'
      ? samsungModels
      : selectedType === 'iphone'
        ? iphoneModels
        : [];

    console.log(modelsToUse);
    if (modelsToUse.length > 0) {
      modelsToUse.forEach((model, index) => {
        const option = document.createElement('option');
        option.value = model.value;
        option.textContent = model.label;
        Object.entries(model.dataset).forEach(([key, value]) => {
          option.dataset[key] = value;
        });
        if (index === 0) option.selected = true;
        modelSelect.appendChild(option);
      });
    } else {
      const fallback = document.createElement('option');
      fallback.textContent = 'No available models';
      fallback.disabled = true;
      fallback.selected = true;
      modelSelect.appendChild(fallback);
    }

    modelSelect.dispatchEvent(new Event('change'));

    observer.observe(modelContainer, { childList: true, subtree: true }); // 👈 Restart observer
  }

  // Run on load
  cacheModelOptions(getModelSelect());
  //updateModelOptions();

  // Run on Type change
  typeSelect.addEventListener('change', updateModelOptions);

  // Start observing in case Model select is replaced by Shopify dynamically
  observer.observe(modelContainer, { childList: true, subtree: true });
});